import {
  StyledCrUserDesignation,
  StyledCrUserInfoContent,
  StyledDropdownCopyTokenItem,
  StyledDropdownWrapper,
  StyledNotifyLink,
  StyledUserHeaderName,
  StyledUserInfoWrapper,
  StyledUsername,
  StyledUsernameInfo,
  StyledUserOfflineDot,
  StyledUserOnlineDot,
} from "./index.styled";
import { Dropdown, Tag, Tooltip, Typography } from "antd";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTypedDispatch, useTypedSelector } from "@lib/redux";
import { logout } from "@lib/redux/slices/auth";
import { FormattedMessage } from "react-intl";
import { MdOutlineKeyboardDoubleArrowDown } from "react-icons/md";
import { userRoleColor } from "@lib/helpers/ColorHelper";
import { shortenString } from "@lib/helpers/StringHelper";
import { copyToken } from "@lib/helpers/Common";

const HeaderUser = () => {
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();
  const { isDark } = useTypedSelector((state) => state.settings);
  const themeMode = isDark ? "dark" : "light";
  const { user } = useTypedSelector((state) => state.auth);
  const { isConnected } = useTypedSelector((state) => state.websocket);
  const { header, window: windowState } = useTypedSelector(
    (state) => state.screen,
  );
  const breakpointHide = windowState?.breakpointHide;
  const isMobile = breakpointHide && window.innerWidth < breakpointHide;

  const userShortName = user?.fullName
    ?.split(" ")
    ?.map((name) => name[0])
    .join("")
    .toLocaleUpperCase();
  const userLongName = shortenString(user?.fullName || "", 10);
  const userName = isMobile ? userShortName : userLongName;

  const items = useMemo(() => {
    const _items = [
      {
        key: 1,
        label: (
          <StyledUserInfoWrapper onClick={() => navigate("/my-profile")}>
            <StyledCrUserInfoContent>
              <StyledUsernameInfo>
                <StyledUsername
                  className={clsx("text-truncate", {
                    light: themeMode === "light",
                  })}
                >
                  {shortenString(user?.fullName || "", 20)}
                </StyledUsername>
              </StyledUsernameInfo>
              <StyledCrUserDesignation>
                {user?.role && (
                  <Tag color={userRoleColor(user?.role)}>{user?.role}</Tag>
                )}
              </StyledCrUserDesignation>
            </StyledCrUserInfoContent>
          </StyledUserInfoWrapper>
        ),
      },
      {
        key: 2,
        label: (
          <div onClick={() => navigate("/my-profile")}>
            <FormattedMessage id="common.myProfile" />
          </div>
        ),
      },
      {
        key: 4,
        label: (
          <div onClick={() => dispatch(logout())}>
            <FormattedMessage id="common.logout" />
          </div>
        ),
      },
    ];

    if (process.env.NODE_ENV === "development") {
      _items.push({
        key: 3,
        label: (
          <StyledDropdownCopyTokenItem
            onClick={() => copyToken(user?.accessToken || "")}
          >
            <FormattedMessage id="common.copyToken" />{" "}
            <span>(Only locale)</span>
          </StyledDropdownCopyTokenItem>
        ),
      });
    }
    // sort with key
    return _items.sort((a, b) => a.key - b.key);
  }, [header?.height, themeMode, user?.fullName, user?.role]);

  return (
    <StyledDropdownWrapper height={header?.height - 5}>
      <Dropdown
        menu={{ items }}
        className="dropdown"
        overlayClassName="header-user-info"
        // getPopupContainer={(triggerNode) => triggerNode}
        trigger={["click"]}
      >
        <StyledNotifyLink onClick={(e) => e.preventDefault()}>
          <StyledUserHeaderName>
            <Tooltip title={isConnected ? "Online" : "Offline"}>
              {isConnected ? <StyledUserOnlineDot /> : <StyledUserOfflineDot />}
            </Tooltip>
            <Typography.Text
              style={{
                fontSize: `${header?.height / 2.5}px`,
              }}
            >
              {userName}
            </Typography.Text>
            <MdOutlineKeyboardDoubleArrowDown />
          </StyledUserHeaderName>
        </StyledNotifyLink>
      </Dropdown>
    </StyledDropdownWrapper>
  );
};

export default HeaderUser;
